import React, { useState } from 'react';
import MainImage from '../../images/portfolio/hogskolenvolda/HeroImage.jpg';
import PortfolioPage from '../../components/PortfolioPage';

const PortfolioHogskolenVolda = () => {
    return <PortfolioPage img={MainImage} url="https://player.vimeo.com/video/599572882" title="Søppelsortering - Høgskulen i Volda" description="I samarbeid med Høgskulen i Volda, har vi produsert en kort video som effektivt demonstrerer hva slags søppel som skal hives i hvilke beholdere. Hensikten er å vise filmen på en skjerm i lokalet til skolen, for å spre informasjon om hva som skal kastes hvor, når det kan være usikkerhet om dette for studenter. Prosjektet ble produsert i sommeren 2021. " />
}

export default PortfolioHogskolenVolda;